import React, { useCallback } from 'react';

import ViewChatCell from '../viewchatcell';

const ViewChatCellRenderer = React.memo(({ data, onClickHandler, t }) => {
    const handleClick = useCallback(() => {
        onClickHandler(data.guid);
    }, [data.guid, onClickHandler]);
    return <ViewChatCell guid={data.guid} onClick={handleClick} t={t} />;
});

export default ViewChatCellRenderer;